module.exports = __webpack_public_path__ + "img/dummy_user.5da2550c.png";